import React from 'react'

import * as FaIcons from 'react-icons/fa'
import { Link } from 'react-router-dom';

import { toggleMenu } from './Home';

import logo from '../images/crodudes_logo_1.png'

/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */


const About = () => {
    return (
        <>
        <header className="row">
            <div className="row logo">
                <div className="logo-box">
                <img src={ logo } alt="" />
                </div>
                <div>
                    CroCodudes
                </div>
            </div>
            <div className="toggle" onClick={ toggleMenu }>
                
            </div>
            <div className="sidebar row">
                <ul className="row">
                    <li onClick={toggleMenu} style={{color: '86A656'}}><Link to="/">Home</Link></li>
                    <li onClick={toggleMenu}><Link to="/minted">Minted</Link></li>
                    <li onClick={toggleMenu}><Link to="/dashboard">Dashboard</Link></li>
                    <li onClick={toggleMenu}><Link to="/about">About us</Link></li>
                    <li><FaIcons.FaWallet /></li>
                </ul>
            </div>
        </header>

        <main className='column about-sec'>
        <div className='about-heading'>
            <h3>About us</h3>
        </div>
        <div className='about-main-sec'>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p><br />
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p><br />
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
        </div>
        </main>
        <footer className='row dash-footer'>
            <div className='main-color-text'>
                Copyright &copy;2022.CroCoDudes. All Rights Reserved
            </div>
            <div className='row'>
                <div>Terms & Conditions</div>
                <div>Privacy Policy</div>
            </div>
        </footer>
        </>
    )
}

export default About


/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */
